import { logout } from '@/store/slices/auth';
import { store } from '@/store';

type ErrorWithCode = {
  code?: string;
};

const UNAUTHENTICATED_CODES = new Set([
  'unauthenticated',
  'functions/unauthenticated',
  'auth/user-token-expired',
  'auth/id-token-expired',
  'auth/invalid-user-token'
]);

export const isUnauthenticatedError = (error: unknown): boolean => {
  const code = (error as ErrorWithCode | undefined)?.code;

  if (!code) {
    return false;
  }

  return UNAUTHENTICATED_CODES.has(code);
};

export const handleUnauthenticatedError = (error: unknown): boolean => {
  if (!isUnauthenticatedError(error)) {
    return false;
  }

  store.dispatch(logout());
  return true;
};
